import { NotFound404 } from "./NotFound404";
export default NotFound404;
